import { useState } from "react";
import LoginForm from "./LoginForm";
import ResetForm from "./ResetForm";
import PttLogo from "../../static/icon/Ptt_login_logo";
import ComfirmPage from "./ComfirmPage";

const Login = ({ history }) => {
  const [currentPageAction, setCurrentPageAction] = useState({
    name: "LOGIN",
    mail: "",
  });
  return (
    <div className="h-screen w-full grid md:grid-cols-2">
      <div className="bg-login logo-login text-center hidden lg:grid lg:col-span-1">
        <div className="flex flex-1 h-full justify-center items-center">
          <PttLogo style={{ fontSize: 300, color: "#fff" }} />
        </div>
      </div>
      <div className="lg:col-span-1 md:col-span-2 bg-white">
        {!(
          currentPageAction.name === "LOGIN" ||
          currentPageAction.name === "COMFIRM_PAGE"
        ) && (
            <div
              className="cursor-pointer hover:opacity-80 ml-12 top-18 absolute"
              onClick={() => setCurrentPageAction({ name: "LOGIN", mail: "" })}
            >
              <svg
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.6666 1.66699L1.33325 11.0003L10.6666 20.3337"
                  stroke="#75B5E3"
                  stroke-width="2.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.33325 11H22.6666"
                  stroke="#75B5E3"
                  stroke-width="2.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          )}
        <div className="font-medium h-full grid items-center justify-center">
          <div>
            {currentPageAction.name === "LOGIN" ? (
              <LoginForm
                setCurrentPageAction={setCurrentPageAction}
                history={history}
              />
            ) : currentPageAction.name === "COMFIRM_PAGE" ? (
              <ComfirmPage
                currentPageAction={currentPageAction}
                setCurrentPageAction={setCurrentPageAction}
              />
            ) : (

              <ResetForm
                currentPageAction={currentPageAction}
                setCurrentPageAction={setCurrentPageAction}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
